import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { ENV_CONFIG } from "common/config/env.config";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    ns: ["cookie", "common", "i18NextSamples"],
    interpolation: {
      escapeValue: false
    },
    debug: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${ENV_CONFIG.BUILD_ID}`
    }
  });

export default i18n;
